import React from "react";
import { Typography } from "@material-ui/core";
import moment from "moment";
import { Body } from "@components";
import { TableSearchColumn } from "@search/TableSearch";
import locale from "@bonliva-crm/locale";
import { ItemType } from "./utils";
import CustomerCol from "./components/CustomerCol";
import AssignToBookingCol from "./components/AssignToBookingCol";
import StatusCol from "./components/StatusCol";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";

export const getColumns = (): Array<TableSearchColumn<ItemType>> => [
  {
    label: locale.Week,
    dataKey: "week",
    vAlign: "center",
    width: 50,
    style: { justifyContent: "center", color: "#535353" },
    cellRenderer: ({ rowData, onRowUpdate, rowIndex }) => (
      <Body>{`V.${moment(rowData.Week).format("W")}`}</Body>
    )
  },
  {
    label: locale.Assigned,
    dataKey: "assigned",
    vAlign: "center",
    width: 100,
    style: { justifyContent: "center", color: "#535353" },
    cellRenderer: ({ rowData, onRowUpdate, rowIndex }) => (
      <AssignToBookingCol key={rowData._id} rowData={rowData} />
    )
  },
  {
    label: locale.Consultant,
    dataKey: "consultant",
    // width: 150,
    vAlign: "center",
    style: { paddingLeft: 0, minWidth: 150 },
    cellRenderer: ({ rowData }) => {
      return <Body>{rowData.ConsultantRef.Name}</Body>;
    }
  },
  {
    label: locale.Customer,
    // width: 200,
    fitted: true,
    dataKey: "customer",
    vAlign: "center",
    style: { minWidth: 260 },
    // width: 160,
    cellRenderer: ({ rowData }) => <CustomerCol key={rowData._id} rowData={rowData} />
  },
  {
    label: locale.AreaOfExpertise,
    // width: 158,
    dataKey: "aoe",
    vAlign: "center",
    style: { minWidth: 120 },
    cellRenderer: ({ rowData }) => (
      <Typography noWrap style={{ maxWidth: 155 }}>
        {rowData.AreaOfExpertise}
      </Typography>
    )
  },
  {
    label: "Kst",
    fitted: true,
    width: 130,
    vAlign: "center",
    dataKey: "costCenter",
    // style: { justifyContent: "center" },
    cellRenderer: ({ rowData }) =>
      rowData.CostCenterId && <Body>{rowData.CostCenterId}</Body>
  },
  {
    width: 96,
    label: locale.Project,
    dataKey: "project",
    vAlign: "center",
    cellRenderer: ({ rowData }) => {
      if (!rowData?.ProjectId) {
        return null;
      }

      return (
        <Body title={`Projektnr: ${rowData?.projectNumber ?? "not found"}`}>
          {rowData?.projectName ?? "not found"}
        </Body>
      );
    }
  },
  {
    width: 72,
    label: "Alt",
    dataKey: "alt",
    vAlign: "center",
    // style: { justifyContent: "center" },
    cellRenderer: ({ rowData }) => (
      <Body style={{ borderBottom: "1px dashed darkkhaki", textAlign: "center" }}>
        {rowData.ContractTypeAbbr}
      </Body>
    )
  },
  {
    width: 145,
    label: "T/R",
    vAlign: "center",
    dataKey: "timeReportStatus",
    // style: { justifyContent: "center" },
    headerStyle: { justifyContent: "center" },
    cellRenderer: ({ rowData }) => (
      <Body>{locale.timeReportStatus[rowData.TimeReportStatus]}</Body>
    )
  },
  {
    width: 150,
    label: locale.fixme,
    vAlign: "center",
    dataKey: "lastKitCreationWfFailedAt",
    style: { justifyContent: "center" },
    cellRenderer: ({ rowData }) => {
      const date = rowData.lastKitCreationWfFailedAt
        ? moment(rowData.lastKitCreationWfFailedAt).format("L")
        : null;

      return (
        <Body
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 4
          }}
        >
          {date ? (
            <>
              <ErrorOutlineIcon
                style={{ color: "red", fontSize: 18, cursor: "pointer" }}
              />
              <Typography variant="caption" display="block">
                {date}
              </Typography>
            </>
          ) : null}
        </Body>
      );
    }
  },
  {
    width: 150,
    label: locale.lastEvent,
    vAlign: "center",
    dataKey: "lastEvent",
    style: { justifyContent: "center" },
    cellRenderer: ({ rowData }) => (
      <Body>
        <Typography variant="caption" display="block">
          {rowData.timeReportStatusSetBy?.Name}
        </Typography>
        <Typography variant="caption" display="block">
          {rowData.timeReportStatusSetOn &&
            moment(rowData.timeReportStatusSetOn).format("L")}
        </Typography>
      </Body>
    )
  },
  {
    label: locale.Status,
    vAlign: "center",
    dataKey: "tag",
    style: { minWidth: 160, maxWidth: 320 },
    cellRenderer: ({ rowData }) => <StatusCol key={rowData._id} rowData={rowData} />
  }
];
